<aside class="ui-sidebar" [class.ui-sidebar--collapsed]="collapsed">
  <app-ui-sidebar-brand
    [logoText]="logoText"
    [companyName]="companyName"
    [appName]="appName"
    [collapsed]="collapsed">
  </app-ui-sidebar-brand>
  <app-ui-sidebar-search
    [collapsed]="collapsed"
    (searchChange)="onSearchChange($event)">
  </app-ui-sidebar-search>
  <app-ui-sidebar-nav
    [sections]="menuSections"
    [activePath]="activePath"
    [collapsed]="collapsed"
    [searchTerm]="searchTerm"
    (navigate)="onNavigate($event)">
  </app-ui-sidebar-nav>
</aside>
